<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="isShowing"
      :persistent="loading"
      width="50vw"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="headline"> {{ title }} </v-card-title>
        <v-card-text style="min-height: 20vh; max-height: 72vh;">
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-show="!loading"
            color="blue darken-1"
            flat
            @click.native="clickNg"
          >
            Cancel
          </v-btn>
          <v-btn
            :loading="loading"
            color="blue darken-1"
            flat
            @click.native="$emit('clickOk')"
          >
            {{ okMsg }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '確認',
    },
    ngMsg: {
      type: String,
      default: 'キャンセル',
    },
    okMsg: {
      type: String,
      default: 'OK',
    },
    message: {
      type: String,
      default: '実行します。よろしいですか？',
    },
  },
  computed: {
    isShowing: {
      get() {
        return this.value
      },
      set(isShow) {
        return this.$emit('input', isShow)
      },
    },
  },
  methods: {
    clickNg() {
      this.$emit('clickNg')
      this.isShowing = false
    },
  },
}
</script>

<style scoped>
.wrap {
  width: 60vw;
}
</style>
